import config from '@/config'
import lang from '@/lang'
import { invoiceStates } from '@/modules/base/util/constants'
const { DRAFT, CANCELLED, PAID, LOCKED, PARTIALLYPAID, DUNNED, OPEN, CREDITED } = invoiceStates

const urls = {
  single: 'invoice',
  multiple: 'invoices',
}

const resourceUrl = `${config.resourceHost}invoice`
const resourceUrlArticle = `${config.resourceHost}article`
const { assetResourceHost } = config

export default {
  resourceUrl,
  resourceUrlArticle,
  assetResourceHost,
  invoiceThumbsUrl: 'reportfinance/getinvoicethumbs',
  invoiceListSetting: `${config.resourceHost}setting/userlist/invoice`,
  invoiceSettingDetails: `${config.resourceHost}setting/invoice`,
  getNextInvoiceNumber: `${resourceUrl}/number`,
  validateInvoice: `${resourceUrl}/validate`,
  getNewInvoice: `${resourceUrl}/new`,
  getInvoiceFactorySetting: `${resourceUrl}/factorySetting`,
  searchUrl: `${resourceUrl}/search`,
  cancellationUrl: `${config.resourceHost}cancellation`,
  creditNoteUrl: `${config.resourceHost}creditNote`,
  getInvoiceCountUrl: `${resourceUrl}/count`,
  preview: `${resourceUrl}/preview`,
  previewCancellation: `${config.resourceHost}cancellation/preview`,
  manualCreditNoteNew: `${config.resourceHost}manualCreditNote/new`,
  manualCreditNoteCopy: id => `${config.resourceHost}manualCreditNote/${id}/copy`,

  getShipmentTypesList: `${config.resourceHost}shipmentType`,

  clientUrl: urls,

  routes: {
    details: `/${urls.single}/`,
    list: `${config.resourceHost}${urls.multiple}`,
  },

  filters: [
    {
      name: 'all',
      title: lang.label.allCapital,
      quickFilter: {
        realState: {
          type: 'set',
          values: [],
        },
      },
    },
    {
      name: 'draft',
      title: lang.draft,
      quickFilter: {
        realState: {
          type: 'set',
          values: [DRAFT],
        },
      },
    },
    {
      name: 'open',
      title: lang.open,
      quickFilter: {
        realState: {
          type: 'set',
          values: [OPEN, LOCKED, PARTIALLYPAID, DUNNED],
        },
      },
    },
    {
      name: 'paid',
      title: lang.paid,
      quickFilter: {
        realState: {
          type: 'set',
          values: [PAID, CANCELLED, CREDITED],
        },
      },
    },
    {
      name: 'cancelled',
      title: lang.cancelled,
      quickFilter: {
        realState: {
          type: 'set',
          values: [CANCELLED],
        },
      },
    },
    {
      name: 'overdue',
      title: lang.overdue,
      quickFilter: {
        isOverDue: {
          type: 'set',
          values: ['true'],
        },
      },
    },
    {
      name: 'dunned',
      title: lang.dunned,
      quickFilter: {
        realState: {
          type: 'set',
          values: [DUNNED],
        },
      },
    },
  ],

  shipping: `${assetResourceHost}/shipping`,
}
